import {HtmlHelper} from '../../../services/htmlHelper';
import {
  ILoginFlow,
  LoginFlowInitializeParams,
  LoginFlowStatusChangeCallback,
} from './loginFlow';
import {PURCHASE_PAGE_CHECKOUT} from '../../../config/paths';
import {EnvConfig} from '../../../config/envConfig.interface';
import {AuthService} from '../../../services/authService';
import {ITrackingService} from '../../../services/gtmHelper';
import {Elem, setHtmlContent} from '../../../services/html';

export class RedirectLoginFlow implements ILoginFlow {
  private container: HTMLElement | null = null;
  constructor(
    protected configuration: EnvConfig,
    protected authService: AuthService,
    protected trackingService: ITrackingService,
  ) {}
  onLoginFlowStatusChange(callback: LoginFlowStatusChangeCallback): void {
    const accessToken = this.getCustomTokenFromUrl();

    if (accessToken) {
      void callback({
        loginFlowStatus: 'finish',
      });
    } else {
      void callback({
        loginFlowStatus: 'start',
      });
    }
  }
  async initialize({container}: LoginFlowInitializeParams) {
    return new Promise<void>(resolve => {
      this.container = container;
      // "You will be redirected to the login page..."
      this.addRedirectMessage(
        'Du wirst auf die Anmeldeseite weitergeleitet...',
      );
      this.trackingService.trackEvent('login_page_view', {}, () =>
        resolve(undefined),
      );
    });
  }
  async startLoginFlow() {
    const redirectUri = HtmlHelper.instance.document.location.href;
    HtmlHelper.instance.redirectTo(
      `${this.configuration.accountManagementUrl}/_/auth?mode=custom_token&finish=redirect&redirect_uri=${redirectUri}`,
    );
  }
  async finishLoginFlow() {
    // "Login Successful. You will be redirected.."
    this.addRedirectMessage('Anmeldung erfolgreich. Du wirst weitergeleitet..');
    const accessToken = this.getCustomTokenFromUrl();
    if (accessToken) {
      await this.authService.signInWithCustomToken(accessToken);
      this.trackingService.trackEvent('login_success', {}, () => {
        this.trackingService.trackEvent('login', {}, () => {
          HtmlHelper.instance.redirectTo(PURCHASE_PAGE_CHECKOUT);
        });
      });
    }
  }
  async signOut() {
    await this.authService.signOut();
  }

  private getCustomTokenFromUrl(): string | null {
    const queryParams = HtmlHelper.instance.getUrlQueryParams(
      HtmlHelper.instance.document.location.search,
    );

    return queryParams['access_token'] ?? null;
  }

  private addRedirectMessage(message: string) {
    if (this.container) {
      const element = Elem('div', {
        text: message,
        class: 'loading-message',
      });

      setHtmlContent(this.container, element);
    }
  }
}
